import { Pipe, PipeTransform } from '@angular/core';
import { FuncMinutes2Format, HoursOutputFormat } from './funcMinutes2HourFormat';

@Pipe({
    name: 'formatHours'
})
export class FormatHoursPipe implements PipeTransform {

    transform(value: number, pattern: HoursOutputFormat) : string {
        try {
            return FuncMinutes2Format.RenderHours(value, pattern);
        } catch {
            return '';
        }
    }
}
